import { IApplicationState } from '../../types/redux';

export const getNewbuildingPromoSnippet = (state: IApplicationState) => state.offersData.newbuildingPromoSnippet;
